import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import FlightDesktopHeader from "./FlightDesktopHeader";
import FlightMobileHeader from "./FlightMobileHeader";

import {FlightSearchStore} from "../../../store/flightSearch/types";
import { useRedirectHome } from '../../../hooks/useRedirectHome';


type Props = {
  navigateHandler?: () => void
  modify: boolean,
  onModifyChange: (value: boolean) => void
  refetchSearch: (arg: FlightSearchStore) => void,
  onOpenFilters?: () => void
}
function FlightHeaderNavigation({ navigateHandler, modify, onModifyChange, refetchSearch, onOpenFilters }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  const redirectHome = useRedirectHome();


  const handleNavigate = () => {
  const isResultsPage = window.location.pathname === "/search-listings";

  if (isResultsPage) {
    redirectHome(); // host if embedded, widget '/' otherwise
    return;
  }

  navigateHandler ? navigateHandler() : navigate(-1);
};

  return (
      <>
        {isMobile ? (
            <FlightMobileHeader navigateHandler={handleNavigate} modify={modify} onModifyChange={onModifyChange} refetchSearch={refetchSearch} onOpenFilters={onOpenFilters} />
        ) : (
            <FlightDesktopHeader navigateHandler={handleNavigate} modify={modify} onModifyChange={onModifyChange} refetchSearch={refetchSearch} />
        )}
      </>
  )
}

FlightHeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default FlightHeaderNavigation;
